import React, { useRef } from 'react';
import { ColumnInstance } from 'react-table';

import { Tr, Td, TableRowProps, TableCellProps } from '@chakra-ui/react';

import { CompositionGroup } from 'types/composition';

import { Row, Cell } from './types';

interface RowProps {
  visibleColumns: ColumnInstance<CompositionGroup>[];
  renderRowSubComponent: (params: {
    group: CompositionGroup;
  }) => React.ReactElement;
  row: Row;
}

const CompositionGroupsTableRow: React.FC<RowProps> = ({
  visibleColumns,
  renderRowSubComponent,
  row,
  ...restProps
}) => {
  const ref = useRef<HTMLTableRowElement>(null);

  function getCustomRowExpandedProps(tableRow: Row): TableRowProps {
    return {
      ...row.getToggleRowExpandedProps(),
      title: 'Editar serviço',
      backgroundColor: tableRow.isExpanded ? 'brand.500' : 'inherit',
      color: tableRow.isExpanded ? 'white' : 'gray.800',
      _hover: {
        color: tableRow.isExpanded ? 'white' : 'gray.800',
        backgroundColor: tableRow.isExpanded ? 'brand.500' : 'gray.200',
      },
    };
  }

  const getCustomCellProps = (cell: Cell): TableCellProps => {
    return {
      onClick: (e) => {
        e.stopPropagation();
        if (cell.column.id !== 'actions' && !!row.original.key) {
          row.toggleRowExpanded();
        }
      },
    };
  };

  return (
    <>
      <Tr
        ref={ref}
        {...row.getRowProps()}
        {...((!!row.original.key && getCustomRowExpandedProps(row)) || {})}
        {...restProps}
      >
        {row.cells.map((cell) => {
          return (
            <Td
              {...cell.getCellProps()}
              {...getCustomCellProps(cell)}
              isNumeric={cell.column.isNumeric}
              borderBottomColor={row.isExpanded ? 'brand.400' : undefined}
              py={4}
            >
              {cell.render('Cell')}
            </Td>
          );
        })}
      </Tr>

      {row.isExpanded ? (
        <Tr
          // backgroundColor={row.isExpanded ? 'gray.50' : 'inherit'}
          border="1px solid white"
          boxShadow="inset 0 0 0 1px #808080"
          sx={{
            '* > table': {
              backgroundColor: 'white',
              borderBottom: 'none',
            },
          }}
        >
          <Td colSpan={visibleColumns.length} paddingY={4} borderBottom="none">
            {renderRowSubComponent({
              group: row.original,
            })}
          </Td>
        </Tr>
      ) : null}
    </>
  );
};

export default CompositionGroupsTableRow;
